$(document).ready(function(){
  var dailyDeals = $(".daily__deals_deal_of_the_deal_box_wrapper");
  var linkProduct = dailyDeals.find('.daily_deals__price_box_wrapper a').attr('href');
  var btnWrap = dailyDeals.find('.daily_deals__btn-holder');
  var btnHtml = '<a href="'+linkProduct+'" class="daily_deals__cta daily_deals__cta-cart">View Details</a>';
  btnWrap.append(btnHtml);
  dailyDeals.find("#atc-main").css({'background':'#ecad1a','color': '#000000'});
  var priceW = dailyDeals.find('#leadProductNewPrice');
  var priceV = dailyDeals.find('#leadProductNewPrice').text();
  if(priceV.includes('.00')){
    priceV = priceV.split('.00')[0];
    priceW.text(priceV);
  };
  
  // setInterval(function () {
  //   var giftClicked = localStorage.getItem('gift_icon');
  //   if(giftClicked == 'clicked'){
  //     var urlL = location.href;
  //     if(urlL.includes("#smile-home")==false){
  //       $("#smile-rewards").hide();
  //       var smilePanel = $('.smile-panel-frame');
  //       if(smilePanel.length > 0){
  //         smilePanel.html('')
  //       }
  //       if($("#smile-ui-container").length > 0){
  //         $("#smile-ui-container").html('');
  //       }
  //       clearInterval();
  //     }
      
  //   }
  // }, 50);
})
